import { Outlet, Link, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { useAdmin } from '../context/AdminContext'

const AdminLayout = () => {
  const { user, logout } = useAuth()
  const { isImpersonating } = useAdmin()
  const location = useLocation()

  const navItems = [
    { path: '/admin', label: 'Dashboard', exact: true },
    // Add more admin nav items as needed
  ]

  return (
    <div className={`min-h-screen bg-slate-50 ${isImpersonating ? 'pt-12' : ''}`}>
      {/* Sidebar */}
      <aside 
        className="fixed inset-y-0 left-0 w-64 bg-slate-900 text-white"
        style={{ top: isImpersonating ? '44px' : '0' }}
      >
        <div className="flex flex-col h-full">
          {/* Logo */}
          <div className="p-6 border-b border-slate-700">
            <div className="flex items-end gap-3">
              <a href="https://insurevision.ai" target="_blank" rel="noopener noreferrer">
               <img 
                  src="/assets/INSUREVISION_AI_LOGO_BLK.svg" 
                  alt="InsureVision" 
                  className="h-8"
                />
              </a>
              <span className="font-display font-bold text-lg text-white">
                FleetVision
              </span>
            </div>
          </div>

          {/* Navigation */}
          <nav className="flex-1 p-4">
            <ul className="space-y-1">
              {navItems.map((item) => {
                const isActive = item.exact 
                  ? location.pathname === item.path
                  : location.pathname.startsWith(item.path)
                
                return (
                  <li key={item.path}>
                    <Link
                      to={item.path}
                      className={`block px-4 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                        isActive
                          ? 'bg-brand-600 text-white'
                          : 'text-slate-300 hover:bg-slate-800 hover:text-white'
                      }`}
                    >
                      {item.label}
                    </Link>
                  </li>
                )
              })}
            </ul>

            {/* Back to App link */}
            <div className="mt-6 pt-6 border-t border-slate-700">
              <Link
                to="/onboarding"
                className="flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium text-slate-300 hover:bg-slate-800 hover:text-white transition-colors"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                Back to App
              </Link>
            </div>
          </nav>

          {/* User info */}
          <div className="p-4 border-t border-slate-700">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 rounded-full bg-brand-600 flex items-center justify-center text-sm font-medium">
                {user?.email?.[0]?.toUpperCase() || 'A'}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-white truncate">
                  {user?.email || 'Admin'}
                </p>
                <p className="text-xs text-slate-400">Administrator</p>
              </div>
            </div>
            <button
              onClick={logout}
              className="w-full px-4 py-2 text-sm text-slate-300 hover:text-white hover:bg-slate-800 rounded-lg transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <div className="pl-64">
        <header 
          className="sticky z-40 bg-white border-b border-slate-200"
          style={{ top: isImpersonating ? '44px' : '0' }}
        >
          <div className="px-8 py-4">
            <h1 className="text-xl font-semibold text-slate-900">Admin Dashboard</h1>
          </div>
        </header>

        <main className="p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default AdminLayout
